import React, { useState, useEffect, useContext, useCallback } from 'react';
import axios, { API_URL } from '../api/axiosConfig';
import { AuthContext } from '../context/AuthContext';
import CargarCUPLModal from './CargarCUPLModal';
import CargarLiquidacionModal from './CargarLiquidacionModal';
import NovedadesTramiteModal from './NovedadesTramiteModal';
import NoEjecutadoModal from './NoEjecutadoModal';
import '../pages/Profiles.css';

// Función para traducir tipos de documento a etiquetas legibles
const getDocumentTypeLabel = (tipoDocumento) => {
  const labels = {
    'Cedula': 'ID Persona Natural / Registro Mercantil Persona Jurídica',
    'Factura': 'Factura de Venta',
    'Declaracion_Importacion': 'Declaración de Importación / Manifiesto',
    'Mandato': 'Mandato / Poder',
    'Tarjeta_Propiedad': 'Tarjeta de Propiedad',
    'Contrato_Prenda': 'Contrato de Prenda',
    'Contrato_Mandato_Prenda': 'Contrato de prenda',
    'Otros_Documentos': 'Otros documentos',
    'FUN': 'FUN',
    'Contrato_Mandato': 'Contrato de mandato',
    'Cedula_Propietario': 'Identificación del propietario',
    'Cedula_Comprador': 'Identificación del comprador',
    'Contrato_Compraventa': 'Contrato de compraventa',
    'Paz_Salvo_Acreedor': 'Paz y salvo del acreedor prendario',
    'Carta_Solicitud': 'Carta de solicitud al organismo de tránsito',
    'Tarjeta Propiedad': 'Tarjeta de Propiedad',
    'Liquidación': 'Liquidación Tránsito',
    'LIQUIDACION_IMPUESTO': 'Liquidación Impuesto (>125cc)',
    'SOPORTE_PAGO_IMPUESTO': 'Soporte Pago Impuesto (>125cc)',
    'CUPL': 'CUPL',
    'SOAT': 'SOAT',
    'SOAT_PAGADO': 'SOAT Pagado',
    'Otros': 'Otro Documento'
  };
  
  return labels[tipoDocumento] || tipoDocumento.replace(/_/g, ' ');
};

const DetalleTramiteModal = ({ isOpen, onClose, tramiteId, onUpdate }) => {
  const { user } = useContext(AuthContext);
  const [tramite, setTramite] = useState(null);
  const [loading, setLoading] = useState(false);
  const [observaciones, setObservaciones] = useState('');
  const [updating, setUpdating] = useState(false);
  const [showNoEjecModal, setShowNoEjecModal] = useState(false);
  const [subiendoFactura, setSubiendoFactura] = useState(false);
  const [generandoCivitrans, setGenerandoCivitrans] = useState(false);

  const [showCUPLModal, setShowCUPLModal] = useState(false);
  const [showLiquidacionModal, setShowLiquidacionModal] = useState(false);
  const [showNovedadesModal, setShowNovedadesModal] = useState(false);

  const [superadminTipoDoc, setSuperadminTipoDoc] = useState('Factura');
  const [superadminFile, setSuperadminFile] = useState(null);
  const [superadminUploading, setSuperadminUploading] = useState(false);

  const isSuperadmin = user?.role === 'superadmin' || user?.profile_name === 'superadmin';

  const handleEliminarArchivoSuperadmin = async (archivoIdKey, nombreDoc) => {
    if (!window.confirm(`¿Está seguro de eliminar el documento "${nombreDoc}" del trámite #${tramiteId}? Esta acción quedará registrada en el historial y auditoría del sistema.`)) {
      return;
    }
    try {
      setUpdating(true);
      await axios.delete(`/api/tramites/${tramiteId}/archivos/${archivoIdKey}`);
      alert('✅ Documento eliminado exitosamente por Superadmin.');
      fetchTramiteDetalle();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert('❌ Error al eliminar documento: ' + (err.response?.data?.message || err.message));
    } finally {
      setUpdating(false);
    }
  };

  const handleSubirArchivoSuperadmin = async (e) => {
    e.preventDefault();
    if (!superadminFile) {
      alert('Por favor seleccione un archivo para cargar.');
      return;
    }
    try {
      setSuperadminUploading(true);
      const formData = new FormData();
      formData.append('file', superadminFile);
      formData.append('tipo_documento', superadminTipoDoc);

      const res = await axios.post(`/api/tramites/${tramiteId}/archivos`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      alert(`✅ ${res.data.message || 'Documento cargado exitosamente por Superadmin.'}`);
      setSuperadminFile(null);
      fetchTramiteDetalle();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert('❌ Error al cargar documento: ' + (err.response?.data?.message || err.message));
    } finally {
      setSuperadminUploading(false);
    }
  };


  const handleGenerarCivitrans = async () => {
    try {
      setGenerandoCivitrans(true);
      const res = await axios.post(`/api/tramites/${tramiteId}/generar-factura-civitrans`);
      alert(`✅ ${res.data.message}`);
      fetchTramiteDetalle();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert(`❌ Error: ${err.response?.data?.message || err.message}`);
    } finally {
      setGenerandoCivitrans(false);
    }
  };

  const handleSubirFacturaDirecta = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (file.size > 6 * 1024 * 1024) {
      alert('❌ El archivo supera los 6MB');
      return;
    }

    try {
      setSubiendoFactura(true);
      const formData = new FormData();
      formData.append('Factura', file);
      
      await axios.put(`/api/tramites/${tramiteId}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      alert('✅ Factura agregada exitosamente');
      fetchTramiteDetalle();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert('❌ Error al subir la factura: ' + (err.response?.data?.message || err.message));
    } finally {
      setSubiendoFactura(false);
    }
  };

  const handleEliminarCUPL = async () => {
    if (!window.confirm('¿Está seguro de eliminar este CUPL? Se eliminará del sistema de pagos y permitirá volver a cargar un nuevo CUPL.')) {
      return;
    }
    try {
      setUpdating(true);
      await axios.delete(`/api/tramites/${tramiteId}/cupl`);
      alert('✅ CUPL eliminado exitosamente.');
      fetchTramiteDetalle();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert('❌ Error al eliminar el CUPL: ' + (err.response?.data?.message || err.message));
    } finally {
      setUpdating(false);
    }
  };

  const handleEliminarLiquidacion = async () => {
    if (!window.confirm('¿Está seguro de eliminar este documento de liquidación?')) {
      return;
    }
    try {
      setUpdating(true);
      await axios.delete(`/api/tramites/${tramiteId}/liquidacion`);
      alert('✅ Liquidación eliminada exitosamente.');
      fetchTramiteDetalle();
      if (onUpdate) onUpdate();
    } catch (err) {
      console.error(err);
      alert('❌ Error al eliminar la liquidación: ' + (err.response?.data?.message || err.message));
    } finally {
      setUpdating(false);
    }
  };

  const fetchTramiteDetalle = useCallback(async () => {
    try {
      setLoading(true);
      const res = await axios.get(`/api/tramites/${tramiteId}`);
      setTramite(res.data);
      setObservaciones(res.data.observaciones_validador || '');
    } catch (err) {
      console.error('Error al cargar detalle del trámite:', err);
    } finally {
      setLoading(false);
    }
  }, [tramiteId]);

  useEffect(() => {
    if (isOpen && tramiteId) {
      fetchTramiteDetalle();
    }
  }, [isOpen, tramiteId, fetchTramiteDetalle]);

  // eslint-disable-next-line no-unused-vars
  const handleAction = async (nuevoEstado) => {
    try {
      setUpdating(true);
      await axios.put(`/api/tramites/${tramiteId}/estado`, {
        estado: nuevoEstado,
        observaciones: observaciones
      });
      onUpdate();
      onClose();
    } catch (err) {
      alert('Error al actualizar el trámite');
    } finally {
      setUpdating(false);
    }
  };

  const checklistItems = tramite ? [
    { 
      key: 'radicado', 
      label: 'Radicado', 
      icon: '📝',
      done: true, // Siempre completado si existe el trámite
      detail: `Fecha: ${new Date(tramite.created_at).toLocaleDateString('es-CO')}`
    },
    { 
      key: 'placa', 
      label: 'Placa Pre-asignada', 
      icon: '🚗',
      done: (tramite.estado !== 'radicado' || tramite.datos_adicionales?.tipo_flujo === 'otros_tramites') && tramite.estado !== 'rechazado',
      detail: tramite.datos_adicionales?.placa_referencia || null
    },
    { 
      key: 'soat', 
      label: 'SOAT', 
      icon: '🛡️',
      done: tramite.datos_adicionales?.soat_cargado === true,
      approved: tramite.datos_adicionales?.soat_aprobado === true,
      detail: tramite.datos_adicionales?.soat_info?.numero 
        ? `N° ${tramite.datos_adicionales.soat_info.numero}` 
        : null
    },
    { 
      key: 'cupl', 
      label: 'CUPL', 
      icon: '📄',
      done: tramite.datos_adicionales?.cupl_cargado === true,
      paid: tramite.datos_adicionales?.cupl_pagado === true,
      detail: tramite.datos_adicionales?.cupl_number 
        ? (user?.concesionario_id && !user?.can_view_cupl
            ? `N° **********${tramite.datos_adicionales.cupl_fecha_vencimiento ? ' • Vence: ' + tramite.datos_adicionales.cupl_fecha_vencimiento : ''}`
            : `N° ${tramite.datos_adicionales.cupl_number}${tramite.datos_adicionales.cupl_fecha_vencimiento ? ' • Vence: ' + tramite.datos_adicionales.cupl_fecha_vencimiento : ''}`
          )
        : null
    },
    { 
      key: 'ejecutado', 
      label: 'Ejecutado', 
      icon: '🔒',
      done: ['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa'].includes(tramite.estado),
      detail: null
    },
    { 
      key: 'en_camino', 
      label: 'Placa en Camino', 
      icon: '🚚',
      done: ['placa_en_camino', 'placa_entregada', 'placa_confirmada'].includes(tramite.estado),
      detail: null
    },
    { 
      key: 'entregada', 
      label: 'Placa Entregada', 
      icon: '🏪',
      done: ['placa_entregada', 'placa_confirmada'].includes(tramite.estado),
      detail: null
    },
    { 
      key: 'confirmada', 
      label: 'Recepción Confirmada', 
      icon: '✅',
      done: tramite.estado === 'placa_confirmada',
      detail: null
    }
  ] : [];

  const getStatusInfo = (status) => {
    const statuses = {
      'radicado': { label: 'Radicado', class: 'pending' },
      'pre_asignado': { label: 'Pre-Asignado', class: 'activo' },
      'novedad_pendiente_soat': { label: 'SOAT Pendiente', class: 'warning' },
      'novedad_soat_cargado': { label: 'SOAT Cargado', class: 'warning' },
      'novedad_soat_vigente': { label: 'SOAT Vigente', class: 'paid' },
      'novedad_pendiente_cupl': { label: 'CUPL Pendiente', class: 'warning' },
      'novedad_cupl_generado': { label: 'CUPL Generado', class: 'warning' },
      'novedad_cupl_pagado': { label: 'CUPL Pagado', class: 'paid' },
      'tramite_ejecutado': { label: 'Trámite Ejecutado', class: 'paid' },
      'placa_en_camino': { label: 'Placa en Camino', class: 'warning' },
      'placa_entregada': { label: 'Placa Entregada', class: 'warning' },
      'placa_confirmada': { label: 'Placa Confirmada', class: 'paid' },
      'incidencia_placa': { label: 'Incidencia Placa', class: 'expired' },
      'rechazado': { label: 'Rechazado', class: 'expired' },
      'eliminado': { label: 'Eliminado 🗑️', class: 'expired' }
    };
    return statuses[status] || { label: status, class: '' };
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="modal-content" style={{ maxWidth: '900px', width: '95%', maxHeight: '95vh', overflowY: 'auto', overflowX: 'hidden', padding: '0' }}>
        {/* Header con color de fondo suave */}
        <div className="modal-header" style={{ padding: '20px 30px', borderBottom: '1px solid #e2e8f0', background: '#f8fafc', position: 'sticky', top: '0', zIndex: '10' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
            <h3 style={{ margin: '0' }}>⚖️ Detalle de Trámite #{tramiteId}</h3>
            {tramite && (
              <span className={`status ${getStatusInfo(tramite.estado).class}`} style={{ fontSize: '12px', padding: '4px 12px' }}>
                {getStatusInfo(tramite.estado).label}
              </span>
            )}
          </div>
          <button className="close-btn" onClick={onClose} style={{ fontSize: '24px', cursor: 'pointer', background: 'none', border: 'none', color: '#64748b' }}>&times;</button>
        </div>

        <div style={{ padding: '30px' }}>
          {loading ? (
            <div style={{ padding: '40px', textAlign: 'center' }}>
              <div className="loading-spinner"></div>
              <p>Cargando información del trámite...</p>
            </div>
          ) : tramite ? (
            <>
              {/* Banner de Rechazo */}
              {tramite.estado === 'rechazado' && (
                <div className="error-banner" style={{ marginBottom: '30px', borderRadius: '12px', padding: '20px', background: '#fef2f2', border: '1px solid #fee2e2', color: '#991b1b' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '20px' }}>❌</span>
                    <strong style={{ fontSize: '16px' }}>Trámite Rechazado</strong>
                  </div>
                  {tramite.observaciones_validador ? (
                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                      <strong>Motivo:</strong> {tramite.observaciones_validador}
                    </p>
                  ) : (
                    <p style={{ margin: 0, fontSize: '14px', fontStyle: 'italic' }}>No se proporcionaron observaciones adicionales.</p>
                  )}
                </div>
              )}

              {/* Banner de Eliminación */}
              {tramite.estado === 'eliminado' && (
                <div className="error-banner" style={{ marginBottom: '30px', borderRadius: '12px', padding: '20px', background: '#fef2f2', border: '1px solid #fca5a5', color: '#991b1b' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '8px' }}>
                    <span style={{ fontSize: '20px' }}>🗑️</span>
                    <strong style={{ fontSize: '16px' }}>Trámite Eliminado</strong>
                  </div>
                  {(tramite.deletion_reason || tramite.observaciones_validador || tramite.datos_adicionales?.deletion_reason) ? (
                    <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                      <strong>Motivo de eliminación:</strong> {tramite.deletion_reason || tramite.observaciones_validador || tramite.datos_adicionales?.deletion_reason}
                    </p>
                  ) : (
                    <p style={{ margin: 0, fontSize: '14px', fontStyle: 'italic' }}>Este trámite ha sido eliminado.</p>
                  )}
                </div>
              )}

              {/* Banner de Estado RUNT No Activo / Sin Registro */}
              {tramite.datos_adicionales?.estado_persona && !tramite.datos_adicionales.estado_persona.toUpperCase().includes('ACTIV') && (
                <div className="warning-banner" style={{ marginBottom: '20px', borderRadius: '12px', padding: '16px 20px', background: '#fef2f2', border: '1px solid #fca5a5', color: '#991b1b', display: 'flex', alignItems: 'center', gap: '12px' }}>
                  <span style={{ fontSize: '24px' }}>⚠️</span>
                  <div>
                    <strong style={{ fontSize: '15px', display: 'block' }}>Alerta de Registro RUNT</strong>
                    <span style={{ fontSize: '13px' }}>
                      El propietario ({tramite.datos_adicionales?.propietario || 'Ciudadano'}) aparece registrado en RUNT como <strong>{tramite.datos_adicionales.estado_persona}</strong>. Debe validar la inscripción del propietario antes de proceder.
                    </span>
                  </div>
                </div>
              )}

              {/* Banner de Novedades Pendientes */}
              {tramite.pending_novelties_count > 0 && (
                <div className="warning-banner" style={{ marginBottom: '30px', borderRadius: '12px', padding: '20px', background: '#fffbeb', border: '1px solid #fde68a', color: '#92400e', display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '15px' }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                    <span style={{ fontSize: '24px' }}>⚠️</span>
                    <div>
                      <strong style={{ fontSize: '16px', display: 'block' }}>Novedades del Trámite</strong>
                      <span style={{ fontSize: '13px' }}>Este trámite tiene incidencias registradas. Consulta los detalles o confirma su solución.</span>
                    </div>
                  </div>
                  <button
                    type="button"
                    onClick={() => setShowNovedadesModal(true)}
                    className="btn-primary"
                    style={{ background: '#d97706', color: '#fff', border: 'none', padding: '10px 20px', borderRadius: '8px', fontSize: '13px', fontWeight: '700', cursor: 'pointer' }}
                  >
                    📋 Subsanar / Ver Novedades
                  </button>
                </div>
              )}

              {/* Checklist de Progreso */}
              <div style={{ marginBottom: '40px', background: '#f8fafc', borderRadius: '16px', padding: '24px', border: '1px solid #e2e8f0' }}>
                <h4 style={{ margin: '0 0 20px 0', display: 'flex', alignItems: 'center', gap: '8px', color: '#1e293b', fontSize: '16px' }}>
                  ✅ Progreso del Trámite
                  <span style={{ fontSize: '12px', color: '#64748b', fontWeight: '400' }}>
                    ({checklistItems.filter(i => i.done).length}/{checklistItems.length} completados)
                  </span>
                </h4>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                  {checklistItems.map((item) => (
                    <div 
                      key={item.key}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '14px',
                        padding: '14px 18px',
                        borderRadius: '12px',
                        background: item.done ? 'white' : 'rgba(255,255,255,0.5)',
                        border: item.done ? '1px solid #bbf7d0' : '1px solid #e2e8f0',
                        transition: 'all 0.2s',
                        opacity: item.done ? 1 : 0.7
                      }}
                    >
                      {/* Checkbox visual */}
                      <div style={{
                        width: '28px',
                        height: '28px',
                        borderRadius: '8px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: '14px',
                        fontWeight: '700',
                        flexShrink: 0,
                        background: item.done ? 'linear-gradient(135deg, #22c55e, #16a34a)' : '#f1f5f9',
                        color: item.done ? 'white' : '#94a3b8',
                        border: item.done ? 'none' : '2px solid #cbd5e1',
                        boxShadow: item.done ? '0 2px 6px rgba(34,197,94,0.3)' : 'none'
                      }}>
                        {item.done ? '✓' : ''}
                      </div>

                      {/* Icono y nombre */}
                      <span style={{ fontSize: '18px' }}>{item.icon}</span>
                      <div style={{ flex: 1 }}>
                        <div style={{ 
                          fontWeight: '600', 
                          fontSize: '14px', 
                          color: item.done ? '#1e293b' : '#64748b',
                          textDecoration: item.done ? 'none' : 'none'
                        }}>
                          {item.label}
                          {/* Sub-badges para SOAT y CUPL */}
                          {item.key === 'soat' && item.done && (
                            <span style={{
                              marginLeft: '8px',
                              fontSize: '10px',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              fontWeight: '700',
                              background: item.approved ? '#dcfce7' : '#fef3c7',
                              color: item.approved ? '#16a34a' : '#d97706'
                            }}>
                              {item.approved ? 'APROBADO' : 'PENDIENTE APROBACIÓN'}
                            </span>
                          )}
                          {item.key === 'cupl' && item.done && (
                            <span style={{
                              marginLeft: '8px',
                              fontSize: '10px',
                              padding: '2px 8px',
                              borderRadius: '4px',
                              fontWeight: '700',
                              background: item.paid ? '#dcfce7' : '#fef3c7',
                              color: item.paid ? '#16a34a' : '#d97706'
                            }}>
                              {item.paid ? 'PAGADO' : 'PENDIENTE PAGO'}
                            </span>
                          )}
                        </div>
                        {item.detail && (
                          <div style={{ fontSize: '12px', color: '#64748b', marginTop: '2px' }}>
                            {item.detail}
                          </div>
                        )}
                      </div>
                      {item.key === 'cupl' && !item.done && !['tramite_ejecutado', 'rechazado', 'eliminado'].includes(tramite.estado) && user?.profile_name !== 'auxiliar transiapp' && !['auxiliar_concesionario', 'administrativo_concesionario'].includes(user?.profile_name) && (user?.role === 'superadmin' || user?.transito_id) && (
                        <button
                          type="button"
                          onClick={() => setShowCUPLModal(true)}
                          style={{
                            padding: '6px 12px',
                            fontSize: '12px',
                            background: '#d97706',
                            color: 'white',
                            border: 'none',
                            borderRadius: '6px',
                            fontWeight: '600',
                            cursor: 'pointer'
                          }}
                        >
                          ➕ Cargar CUPL
                        </button>
                      )}
                    </div>
                  ))}
                </div>
              </div>

              <div className="detalle-tramite-grid" style={{ display: 'grid', gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)', gap: '30px' }}>
                {/* Columna Izquierda: Datos Principales & Vehículo */}
                <div className="detalle-info" style={{ minWidth: 0 }}>
                  {/* Card Propietario & Trámite */}
                  <div className="info-section">
                    <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', color: '#1e293b', fontSize: '15px' }}>
                      👤 Información del Propietario y Trámite
                    </h4>
                    <div className="info-card" style={{ background: '#f8fafc', padding: '18px', borderRadius: '12px', border: '1px solid #e2e8f0' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
                        <p style={{ margin: 0 }}>
                          <strong>Propietario:</strong> {tramite.datos_adicionales?.propietario || 'N/A'}
                          {tramite.datos_adicionales?.documento && (
                            <span style={{ color: '#475569', marginLeft: '6px' }}>
                              ({tramite.datos_adicionales?.tipo_documento === 'NIT' ? 'Registro Mercantil' : 'ID Persona Natural'}: {tramite.datos_adicionales.documento})
                            </span>
                          )}
                        </p>
                        {tramite.datos_adicionales?.estado_persona && (
                          <p style={{ margin: 0 }}>
                            <strong>Estado RUNT:</strong>{' '}
                            <span style={{ 
                              fontSize: '11px', 
                              padding: '2px 8px', 
                              borderRadius: '4px', 
                              fontWeight: '700', 
                              background: tramite.datos_adicionales.estado_persona.toUpperCase().includes('ACTIV') ? '#dcfce7' : '#fee2e2',
                              color: tramite.datos_adicionales.estado_persona.toUpperCase().includes('ACTIV') ? '#16a34a' : '#991b1b',
                              border: tramite.datos_adicionales.estado_persona.toUpperCase().includes('ACTIV') ? '1px solid #bbf7d0' : '1px solid #fca5a5'
                            }}>
                              {tramite.datos_adicionales.estado_persona.toUpperCase().includes('ACTIV')
                                ? `✅ ${tramite.datos_adicionales.estado_persona}`
                                : `⚠️ ${tramite.datos_adicionales.estado_persona}`}
                            </span>
                          </p>
                        )}
                        <p style={{ margin: 0 }}>
                          <strong>Placa:</strong>{' '}
                          <span style={{ fontWeight: 'bold', fontSize: '14px', background: '#fef08a', color: '#854d0e', padding: '2px 8px', borderRadius: '6px', border: '1px solid #ca8a04', fontFamily: 'monospace' }}>
                            {tramite.datos_adicionales?.placa_referencia || 'N/A'}
                          </span>
                        </p>
                        <p style={{ margin: 0 }}><strong>Tipo Trámite:</strong> {tramite.tramite_type_name}</p>
                        {tramite.datos_adicionales?.nuevo_color && (
                          <p style={{ margin: 0 }}>
                            <strong>Nuevo Color Solicitado:</strong>{' '}
                            <span style={{ fontWeight: 'bold', color: '#0369a1', background: '#e0f2fe', padding: '2px 8px', borderRadius: '4px', border: '1px solid #bae6fd' }}>
                              🎨 {tramite.datos_adicionales.nuevo_color}
                            </span>
                          </p>
                        )}
                        <p style={{ margin: 0 }}><strong>Organismo Tránsito:</strong> {tramite.transito_name}</p>
                        {(user?.role === 'superadmin' || user?.profile_name === 'superadmin') && (
                          <p style={{ margin: 0 }}><strong>Solicitante:</strong> {tramite.creador_name}</p>
                        )}
                        <p style={{ margin: 0 }}><strong>Fecha Radicación:</strong> {new Date(tramite.created_at).toLocaleString('es-CO')}</p>
                        {(tramite.datos_adicionales?.observaciones || tramite.observaciones) && (
                          <div style={{ marginTop: '6px', paddingTop: '6px', borderTop: '1px dashed #cbd5e1' }}>
                            <strong>Observaciones:</strong>
                            <div style={{ 
                              color: '#1e293b', 
                              fontStyle: 'italic', 
                              background: '#ffffff', 
                              padding: '6px 10px', 
                              borderRadius: '6px', 
                              border: '1px solid #cbd5e1', 
                              marginTop: '4px',
                              whiteSpace: 'pre-wrap',
                              lineHeight: '1.4'
                            }}>
                              💬 {tramite.datos_adicionales?.observaciones || tramite.observaciones}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Card Detalles del Vehículo */}
                  <div className="info-section" style={{ marginTop: '20px' }}>
                    <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', color: '#1e293b', fontSize: '15px' }}>
                      🚗 Información del Vehículo
                    </h4>
                    <div className="info-card" style={{ background: '#f0fdf4', padding: '18px', borderRadius: '12px', border: '1px solid #bbf7d0' }}>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
                        {tramite.datos_adicionales?.vehicleDetails?.vehiculo ? (
                          <>
                            <p style={{ margin: 0 }}><strong>Marca:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.marca || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Línea:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.linea || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Modelo:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.modelo || 'N/A'}</p>
                            <p style={{ margin: 0 }}>
                              <strong>Cilindraje:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.cilindraje || tramite.datos_adicionales.vehicleDetails.vehiculo.datos_completos?.rna?.datos?.cilindraje || 'N/A'} cc
                            </p>
                            <p style={{ margin: 0 }}><strong>Color:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.color || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Motor:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.nro_motor || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Chasis:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.nro_chasis || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>VIN:</strong> {tramite.datos_adicionales.vehicleDetails.vehiculo.nro_vin || 'N/A'}</p>
                          </>
                        ) : (
                          <>
                            <p style={{ margin: 0 }}><strong>Marca:</strong> {tramite.datos_adicionales?.marca || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Línea:</strong> {tramite.datos_adicionales?.linea || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Modelo:</strong> {tramite.datos_adicionales?.modelo || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Cilindraje:</strong> {tramite.datos_adicionales?.cilindraje ? `${tramite.datos_adicionales.cilindraje} cc` : 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Motor:</strong> {tramite.datos_adicionales?.motor || 'N/A'}</p>
                            <p style={{ margin: 0 }}><strong>Chasis:</strong> {tramite.datos_adicionales?.chasis || 'N/A'}</p>
                          </>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Traspaso: comprador (nuevo propietario) */}
                  {tramite.datos_adicionales?.comprador_nombre && (
                    <div className="info-section" style={{ marginTop: '20px' }}>
                      <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', color: '#1e293b', fontSize: '15px' }}>
                        👤 Comprador {tramite.datos_adicionales.incluye_levante_prenda ? '· traspaso con levantamiento de prenda' : ''}
                      </h4>
                      <div className="info-card" style={{ background: '#f5f3ff', padding: '18px', borderRadius: '12px', border: '1px solid #ddd6fe' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
                          <p style={{ margin: 0 }}><strong>Nombre:</strong> {tramite.datos_adicionales.comprador_nombre}</p>
                          <p style={{ margin: 0 }}><strong>Documento:</strong> {tramite.datos_adicionales.comprador_tipo_documento} {tramite.datos_adicionales.comprador_documento}</p>
                          {tramite.datos_adicionales.comprador_telefono && <p style={{ margin: 0 }}><strong>Teléfono:</strong> {tramite.datos_adicionales.comprador_telefono}</p>}
                          {tramite.datos_adicionales.comprador_estado_persona && <p style={{ margin: 0 }}><strong>Estado RUNT:</strong> {tramite.datos_adicionales.comprador_estado_persona}</p>}
                          {tramite.datos_adicionales.tramite_vinculado_id && <p style={{ margin: 0 }}><strong>Trámite vinculado:</strong> #{tramite.datos_adicionales.tramite_vinculado_id}</p>}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Sección del Acreedor Prendario */}
                  {(tramite.datos_adicionales?.acreedor_nombre || tramite.datos_adicionales?.acreedor_documento) && (
                    <div className="info-section" style={{ marginTop: '20px' }}>
                      <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', color: '#1e293b', fontSize: '15px' }}>
                        🏦 Acreedor Prendario
                      </h4>
                      <div className="info-card" style={{ background: '#f0f9ff', padding: '18px', borderRadius: '12px', border: '1px solid #bae6fd' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
                          <p style={{ margin: 0 }}><strong>Acreedor:</strong> {tramite.datos_adicionales.acreedor_nombre}</p>
                          <p style={{ margin: 0 }}>
                            <strong>Documento:</strong> {tramite.datos_adicionales.acreedor_tipo_documento === 'NIT' ? 'Registro Mercantil' : 'ID Persona Natural'}: {tramite.datos_adicionales.acreedor_documento}
                          </p>
                          {tramite.datos_adicionales.acreedor_estado_persona && (
                            <p style={{ margin: 0 }}>
                              <strong>Estado RUNT:</strong> {' '}
                              <span style={{ 
                                fontSize: '11px', 
                                padding: '2px 8px', 
                                borderRadius: '4px', 
                                fontWeight: '700', 
                                background: tramite.datos_adicionales.acreedor_estado_persona.toUpperCase().includes('ACTIV') ? '#dcfce7' : '#fee2e2',
                                color: tramite.datos_adicionales.acreedor_estado_persona.toUpperCase().includes('ACTIV') ? '#16a34a' : '#991b1b'
                              }}>
                                {tramite.datos_adicionales.acreedor_estado_persona}
                              </span>
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Sección de Información del CUPL */}
                  {(tramite.datos_adicionales?.cupl_number || tramite.datos_adicionales?.cupl_cargado || tramite.datos_adicionales?.cupl_total) && (
                    <div className="info-section" style={{ marginTop: '20px' }}>
                      <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '12px', color: '#1e293b', fontSize: '15px' }}>
                        📄 Información del CUPL
                      </h4>
                      <div className="info-card" style={{ background: '#fffbe8', padding: '18px', borderRadius: '12px', border: '1px solid #fef08a' }}>
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', fontSize: '13px' }}>
                          <p style={{ margin: 0 }}>
                            <strong>N° CUPL:</strong>{' '}
                            <span style={{ fontWeight: 'bold', fontSize: '14px', background: '#fef3c7', color: '#92400e', padding: '2px 8px', borderRadius: '6px', fontFamily: 'monospace' }}>
                              {tramite.datos_adicionales?.cupl_number || 'N/A'}
                            </span>
                          </p>
                          {tramite.datos_adicionales?.cupl_total && (
                            <p style={{ margin: 0 }}>
                              <strong>Valor Total CUPL:</strong> ${Number(tramite.datos_adicionales.cupl_total).toLocaleString('es-CO')}
                            </p>
                          )}
                          <p style={{ margin: 0 }}>
                            <strong>Estado Pago:</strong>{' '}
                            <span style={{
                              fontSize: '12px',
                              padding: '2px 8px',
                              borderRadius: '6px',
                              fontWeight: '700',
                              background: tramite.datos_adicionales?.cupl_pagado ? '#dcfce7' : '#fee2e2',
                              color: tramite.datos_adicionales?.cupl_pagado ? '#16a34a' : '#991b1b'
                            }}>
                              {tramite.datos_adicionales?.cupl_pagado ? '✅ PAGADO' : '⏳ PENDIENTE DE PAGO'}
                            </span>
                          </p>
                          {tramite.datos_adicionales?.cupl_fecha_vencimiento && (
                            <p style={{ margin: 0 }}>
                              <strong>Fecha Vencimiento:</strong> {tramite.datos_adicionales.cupl_fecha_vencimiento}
                            </p>
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {(user?.role === 'superadmin' || user?.role === 'admin') && tramite.estado === 'radicado' && (
                    <div className="info-section" style={{ marginTop: '20px' }}>
                      <h4 style={{ marginBottom: '10px' }}>✍️ Observaciones de Validación</h4>
                      <textarea
                        value={observaciones}
                        onChange={(e) => setObservaciones(e.target.value)}
                        placeholder="Escriba aquí los motivos del rechazo o notas para el trámite..."
                        rows="4"
                        style={{ width: '100%', padding: '15px', borderRadius: '10px', border: '1px solid #cbd5e1', fontSize: '14px', resize: 'none' }}
                      />
                    </div>
                  )}
                </div>

                {/* Columna Derecha: Documentos (Factura, Cédula, Manifiesto, etc con botón Ver) */}
                <div className="detalle-docs" style={{ minWidth: 0 }}>
                  <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px', color: '#1e293b', fontSize: '15px' }}>
                    📂 Documentos del Trámite
                  </h4>

                  {/* Panel de Carga / Reemplazo de Documentos para Superadmin */}
                  {isSuperadmin && (
                    <div style={{ background: '#f0fdf4', border: '1px solid #86efac', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px' }}>
                      <strong style={{ fontSize: '14px', color: '#166534', display: 'block', marginBottom: '4px' }}>
                        🛠️ Cargar / Reemplazar Documento (Superadmin)
                      </strong>
                      <span style={{ fontSize: '12px', color: '#15803d', display: 'block', marginBottom: '12px' }}>
                        Permite adjuntar o reemplazar cualquier documento en cualquier estado del trámite. Quedará registrado en la auditoría.
                      </span>
                      <form onSubmit={handleSubirArchivoSuperadmin} style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
                          <select 
                            value={superadminTipoDoc} 
                            onChange={(e) => setSuperadminTipoDoc(e.target.value)}
                            style={{ padding: '8px 12px', borderRadius: '8px', border: '1px solid #cbd5e1', fontSize: '13px', background: 'white', fontWeight: '600' }}
                          >
                            <option value="Factura">Factura de Venta</option>
                            <option value="Liquidación">Liquidación Tránsito</option>
                            <option value="CUPL">CUPL</option>
                            <option value="SOAT">SOAT</option>
                            <option value="LIQUIDACION_IMPUESTO">Liquidación Impuesto (>125cc)</option>
                            <option value="SOPORTE_PAGO_IMPUESTO">Soporte Pago Impuesto (>125cc)</option>
                            <option value="Cedula">ID Persona Natural / Registro Mercantil Persona Jurídica</option>
                            <option value="Mandato">Mandato / Poder</option>
                            <option value="Tarjeta_Propiedad">Tarjeta de Propiedad</option>
                            <option value="Contrato_Prenda">Contrato de Prenda</option>
                            <option value="Otros">Otro Documento</option>
                          </select>
                          <input 
                            type="file" 
                            onChange={(e) => setSuperadminFile(e.target.files[0])}
                            style={{ fontSize: '12px', flex: 1, padding: '4px' }}
                          />
                        </div>
                        <button 
                          type="submit" 
                          disabled={superadminUploading || !superadminFile}
                          style={{ 
                            padding: '8px 16px', 
                            borderRadius: '8px', 
                            background: '#16a34a', 
                            color: 'white', 
                            border: 'none', 
                            fontWeight: '700', 
                            fontSize: '13px', 
                            cursor: 'pointer',
                            alignSelf: 'flex-start'
                          }}
                        >
                          {superadminUploading ? '⏳ Subiendo...' : '🚀 Cargar Documento (Superadmin)'}
                        </button>
                      </form>
                    </div>
                  )}

                  {(user?.role === 'superadmin' || user?.transito_id || user?.role === 'transito' || user?.can_view_liquidacion) && (
                    <div style={{ 
                      background: '#ecfdf5', 
                      border: '1px solid #a7f3d0', 
                      borderRadius: '12px', 
                      padding: '16px 20px', 
                      marginBottom: '20px' 
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ fontSize: '20px' }}>💵</span>
                          <div>
                            <strong style={{ fontSize: '14px', color: '#065f46', display: 'block' }}>Documento de Liquidación</strong>
                            {tramite.liquidacion_archivo_url ? (
                              <span style={{ fontSize: '12px', color: '#047857', display: 'block', wordBreak: 'break-all', fontWeight: '600' }}>
                                📄 {tramite.liquidacion_archivo_url.split('/').pop()}
                              </span>
                            ) : (
                              <span style={{ fontSize: '12px', color: '#047857', display: 'block' }}>Documento de soporte oficial</span>
                            )}
                            {tramite.datos_adicionales?.total_liquidacion && (
                              <div style={{ marginTop: '5px', fontSize: '14px', fontWeight: 'bold', color: '#064e3b', background: '#d1fae5', padding: '4px 8px', borderRadius: '4px', display: 'inline-block' }}>
                                Total: ${tramite.datos_adicionales.total_liquidacion.toLocaleString('es-CO')}
                              </div>
                            )}
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px' }}>
                          {tramite.liquidacion_archivo_url ? (
                            <>
                              <a 
                                href={`${API_URL}/${tramite.liquidacion_archivo_url.replace(/^\//, '')}`} 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="btn-view-doc"
                                style={{ 
                                  padding: '8px 14px', 
                                  fontSize: '13px', 
                                  textDecoration: 'none',
                                  background: '#10b981',
                                  color: '#ffffff',
                                  borderRadius: '8px',
                                  fontWeight: '700',
                                  display: 'flex',
                                  alignItems: 'center',
                                  gap: '6px'
                                }}
                              >
                                👁️ Ver
                              </a>
                              {(isSuperadmin || (!['rechazado', 'eliminado'].includes(tramite.estado) && user?.profile_name !== 'auxiliar transiapp' && !['auxiliar_concesionario', 'administrativo_concesionario'].includes(user?.profile_name))) && (
                                <button
                                  type="button"
                                  onClick={() => isSuperadmin ? handleEliminarArchivoSuperadmin('liquidacion', 'Liquidación') : handleEliminarLiquidacion()}
                                  disabled={updating}
                                  style={{
                                    padding: '8px 14px',
                                    fontSize: '13px',
                                    background: '#ef4444',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '700',
                                    cursor: 'pointer'
                                  }}
                                  title="Eliminar documento de liquidación"
                                >
                                  🗑️ Eliminar
                                </button>
                              )}
                            </>
                          ) : (
                            !['rechazado', 'eliminado'].includes(tramite.estado) && user?.profile_name !== 'auxiliar transiapp' && !['auxiliar_concesionario', 'administrativo_concesionario'].includes(user?.profile_name) && (
                              (tramite.transito_id === 4 || (tramite.transito_name && tramite.transito_name.toUpperCase().includes('SABANAGRANDE'))) ? (
                                <button
                                  type="button"
                                  onClick={handleGenerarCivitrans}
                                  disabled={generandoCivitrans}
                                  style={{
                                    padding: '8px 14px',
                                    fontSize: '13px',
                                    background: '#2563eb',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '700',
                                    cursor: 'pointer'
                                  }}
                                >
                                  {generandoCivitrans ? '⏳ Generando...' : '⚡ Liquidación Civitrans'}
                                </button>
                              ) : (
                                <button
                                  type="button"
                                  onClick={() => setShowLiquidacionModal(true)}
                                  style={{
                                    padding: '8px 14px',
                                    fontSize: '13px',
                                    background: '#047857',
                                    color: '#ffffff',
                                    border: 'none',
                                    borderRadius: '8px',
                                    fontWeight: '700',
                                    cursor: 'pointer'
                                  }}
                                >
                                  ➕ Cargar Liquidación
                                </button>
                              )
                            )
                          )}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* FUN y contrato de mandato diligenciados (disponibles desde la preasignación de placa) */}
                  {(tramite.pre_assigned_plate_id || ['traspaso', 'levantamiento_prenda'].includes(tramite.datos_adicionales?.subtipo)) && !user?.transito_id && user?.role !== 'transito' && (
                    <div style={{ background: '#eff6ff', border: '1px solid #bfdbfe', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div>
                          <strong style={{ fontSize: '14px', color: '#1e3a8a', display: 'block' }}>📝 Documentos para firma</strong>
                          <span style={{ fontSize: '12px', color: '#1d4ed8' }}>
                            FUN y contrato de mandato {tramite.datos_adicionales?.tipo_documento === 'NIT' ? '(persona jurídica)' : '(persona natural)'} diligenciados
                          </span>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                          {[['fun', '⬇️ FUN'], ['contrato', '⬇️ Contrato de mandato']].map(([tipo, label]) => (
                            <a key={tipo}
                              href={`${API_URL}/api/tramites/${tramite.id}/documento-preasignacion/${tipo}?token=${localStorage.getItem('token')}`}
                              target="_blank" rel="noopener noreferrer"
                              style={{ padding: '8px 14px', fontSize: '13px', textDecoration: 'none', background: '#2563eb', color: '#fff', borderRadius: '8px', fontWeight: '700' }}
                            >{label}</a>
                          ))}
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Documento SOAT para visualización de asesores y cualquier perfil */}
                  {(tramite.datos_adicionales?.soat_cargado || tramite.datos_adicionales?.soat_info || tramite.archivos?.some(f => f.tipo_documento === 'SOAT_PAGADO' || /soat/i.test(f.tipo_documento || ''))) && (
                    <div style={{ 
                      background: '#f0fdf4', 
                      border: '1px solid #bbf7d0', 
                      borderRadius: '12px', 
                      padding: '16px 20px', 
                      marginBottom: '20px' 
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '10px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <span style={{ fontSize: '20px' }}>🛡️</span>
                          <div>
                            <strong style={{ fontSize: '14px', color: '#166534', display: 'block' }}>Documento de SOAT</strong>
                            <span style={{ fontSize: '12px', color: '#15803d', display: 'block', fontWeight: '600' }}>
                              {tramite.datos_adicionales?.soat_info?.numero 
                                ? `N° ${tramite.datos_adicionales.soat_info.numero} (${tramite.datos_adicionales.soat_info.aseguradora || 'Aseguradora'})` 
                                : 'Documento SOAT Verificado'}
                            </span>
                          </div>
                        </div>
                        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                          <a 
                            href={`${API_URL}/api/tramites/${tramite.id}/soat-pdf?token=${localStorage.getItem('token')}`} 
                            target="_blank" 
                            rel="noopener noreferrer"
                            className="btn-view-doc"
                            style={{ 
                              padding: '8px 14px', 
                              fontSize: '13px', 
                              textDecoration: 'none',
                              background: '#16a34a',
                              color: '#ffffff',
                              borderRadius: '8px',
                              fontWeight: '700',
                              display: 'flex',
                              alignItems: 'center',
                              gap: '6px'
                            }}
                          >
                            👁️ Ver SOAT
                          </a>
                          {isSuperadmin && (
                            <button
                              type="button"
                              onClick={() => handleEliminarArchivoSuperadmin('soat', 'SOAT')}
                              disabled={updating}
                              style={{
                                padding: '8px 14px',
                                fontSize: '13px',
                                background: '#ef4444',
                                color: '#ffffff',
                                border: 'none',
                                borderRadius: '8px',
                                fontWeight: '700',
                                cursor: 'pointer'
                              }}
                              title="Eliminar SOAT por Superadmin"
                            >
                              🗑️ Eliminar
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  )}
                  
                  {/* Intentos de ejecución no exitosos (visible para asesor, tránsito y Transiapp) */}
                  {Array.isArray(tramite.intentos_ejecucion) && tramite.intentos_ejecucion.length > 0 && (
                    <div role="status" style={{ background: '#fffbeb', border: '1px solid #fcd34d', borderRadius: '12px', padding: '14px 18px', marginBottom: '20px' }}>
                      <strong style={{ fontSize: '14px', color: '#92400e', display: 'block', marginBottom: '8px' }}>
                        ⛔ Intentos de ejecución no exitosos ({tramite.intentos_ejecucion.length})
                      </strong>
                      {tramite.intentos_ejecucion.map((i, idx) => (
                        <div key={idx} style={{ fontSize: '12px', color: '#78350f', padding: '6px 0', borderTop: idx ? '1px dashed #fde68a' : 'none' }}>
                          <strong>{i.motivo}</strong>{i.observaciones ? ` · ${i.observaciones}` : ''}
                          <div style={{ color: '#a16207' }}>
                            {new Date(i.fecha).toLocaleString('es-CO', { timeZone: 'America/Bogota' })} · {i.usuario}
                            {' · '}
                            {i.status === 'activo'
                              ? (i.bloquea_finalizar ? 'Pendiente de reintento' : (i.genera_novedad ? 'Pendiente de subsanar novedad' : 'Reintento habilitado'))
                              : 'Resuelto'}
                          </div>
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Impuesto Vehicular (zona Atlántico): visible para todos los usuarios del concesionario */}
                  {tramite.is_atlantico && (() => {
                    const estadoImp = String(tramite.impuesto_estado || 'no_registrado').toLowerCase();
                    const registradoYPagado = ['pagado', 'cobrado', 'recaudado'].includes(estadoImp);
                    const archivosImp = (tramite.archivos || []).filter(f => /impuest/i.test(f.tipo_documento || ''));
                    const findDoc = (re) => archivosImp.find(f => re.test(f.tipo_documento || ''));
                    const toUrl = (u) => (!u ? null : /^https?:/i.test(u) ? u : `${API_URL}${u.startsWith('/') ? '' : '/'}${u}`);
                    const da = tramite.datos_adicionales || {};
                    const liqFile = findDoc(/liquidac/i);
                    const sopFile = findDoc(/sopor/i);
                    const docs = [
                      { label: 'Liquidación Impuesto', url: liqFile ? `${API_URL}/uploads/tramites/${liqFile.nombre_disco}` : toUrl(da.impuesto_liquidacion_url || da.liquidacion_impuesto_url) },
                      { label: 'Soporte Pago Impuesto', url: sopFile ? `${API_URL}/uploads/tramites/${sopFile.nombre_disco}` : toUrl(da.impuesto_soporte_url || da.soporte_impuesto_url || da.soporte_pago_impuesto_url) }
                    ];
                    const hayDocs = docs.some(d => d.url);
                    const ccRaw = da.cilindraje || da.vehicleDetails?.vehiculo?.cilindraje || da.vehicleDetails?.vehiculo?.datos_completos?.rna?.datos?.cilindraje || '';
                    const cc = parseInt((String(ccRaw).match(/\d+/) || [0])[0], 10) || 0;
                    const aplicaImpuesto = cc > 125 || hayDocs || Number(tramite.impuesto_valor) > 0 || !['no_registrado', 'pendiente'].includes(estadoImp);
                    if (!aplicaImpuesto) return null;
                    return (
                      <div style={{ background: '#fff7ed', border: '1px solid #fed7aa', borderRadius: '12px', padding: '16px 20px', marginBottom: '20px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: (registradoYPagado && hayDocs) ? '12px' : 0 }}>
                          <span style={{ fontSize: '20px' }} aria-hidden="true">🧾</span>
                          <div>
                            <strong style={{ fontSize: '14px', color: '#9a3412', display: 'block' }}>Impuesto Vehicular (Gobernación del Atlántico)</strong>
                            <span style={{ fontSize: '12px', color: '#c2410c', fontWeight: '600', display: 'block' }}>
                              {registradoYPagado && hayDocs
                                ? `Registrado y pagado${tramite.impuesto_valor ? ` · $${Number(tramite.impuesto_valor).toLocaleString('es-CO')}` : ''}`
                                : 'Pendiente de registro por parte de la Gobernación'}
                            </span>
                          </div>
                        </div>
                        {registradoYPagado && hayDocs && (
                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {docs.filter(d => d.url).map(d => (
                              <a key={d.label} href={d.url} target="_blank" rel="noopener noreferrer" className="btn-view-doc"
                                style={{ padding: '8px 14px', fontSize: '13px', textDecoration: 'none', background: '#ea580c', color: '#ffffff', borderRadius: '8px', fontWeight: '700' }}>
                                👁️ Ver {d.label}
                              </a>
                            ))}
                          </div>
                        )}
                      </div>
                    );
                  })()}

                  {tramite && tramite.archivos && tramite.datos_adicionales?.tipo_flujo !== 'otros_tramites' && !tramite.archivos.some(f => f.tipo_documento === 'Factura') && (
                    <div style={{ 
                      background: '#fff7ed', 
                      border: '1px solid #ffedd5', 
                      borderRadius: '12px', 
                      padding: '16px 20px', 
                      color: '#c2410c', 
                      marginBottom: '20px' 
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '6px' }}>
                        <span style={{ fontSize: '18px' }}>⚠️</span>
                        <strong style={{ fontSize: '14px', color: '#ea580c' }}>Trámite sin Factura Adjunta</strong>
                      </div>
                      <p style={{ margin: '0 0 12px 0', fontSize: '12px', lineHeight: '1.4', color: '#9a3412' }}>
                        Este trámite no cuenta con una factura de venta cargada. Puede adjuntarla ahora mismo:
                      </p>
                      {(!['tramite_ejecutado', 'rechazado', 'eliminado'].includes(tramite.estado) || isSuperadmin) ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <input 
                            type="file" 
                            onChange={handleSubirFacturaDirecta} 
                            accept=".pdf,image/*" 
                            style={{ fontSize: '12px' }} 
                            disabled={subiendoFactura || generandoCivitrans}
                          />
                          {subiendoFactura && <span style={{ fontSize: '12px', color: '#ea580c' }}>⏳ Subiendo...</span>}
                        </div>
                      ) : (
                        <span style={{ fontSize: '11px', color: '#9a3412', fontStyle: 'italic' }}>
                          No se puede subir factura en un trámite ejecutado o rechazado.
                        </span>
                      )}
                    </div>
                  )}

                  <div className="docs-list" style={{ display: 'flex', flexDirection: 'column', gap: '15px', minWidth: 0, maxWidth: '100%' }}>
                    {tramite.archivos && tramite.archivos.length > 0 ? (
                      tramite.archivos
                        .filter(archivo => {
                          if (archivo.tipo_documento.toUpperCase().includes('LIQUIDACION') || archivo.nombre_disco.toLowerCase().includes('civitrans')) {
                            return false;
                          }
                          // Los documentos de impuesto se muestran en su propio bloque
                          if (/impuest/i.test(archivo.tipo_documento || '')) return false;
                          if (archivo.tipo_documento.toUpperCase().includes('CUPL')) {
                            if (user?.concesionario_id && !user?.can_view_cupl) return false;
                          }
                          return true;
                        })
                        .map(archivo => (
                        <div key={archivo.id} className="doc-item" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box', padding: '15px', background: 'white', borderRadius: '10px', border: '1px solid #e2e8f0', boxShadow: '0 2px 4px rgba(0,0,0,0.02)' }}>
                          <div style={{ flex: 1, minWidth: 0, marginRight: '15px', overflow: 'hidden' }}>
                            <span style={{ fontSize: '10px', fontWeight: '800', color: '#2563eb', display: 'block', textTransform: 'uppercase', marginBottom: '4px' }}>
                              {getDocumentTypeLabel(archivo.tipo_documento)}
                            </span>
                            <span style={{ fontSize: '14px', fontWeight: '600', color: '#334155', display: 'block', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }} title={archivo.nombre_mostrar}>
                              {archivo.nombre_mostrar}
                            </span>
                          </div>
                          <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
                            <a 
                              href={`${API_URL}/uploads/tramites/${archivo.nombre_disco}`} 
                              target="_blank" 
                              rel="noopener noreferrer"
                              className="btn-view-doc"
                              style={{ 
                                padding: '8px 14px', 
                                fontSize: '13px', 
                                textDecoration: 'none',
                                background: '#f1f5f9',
                                color: '#475569',
                                borderRadius: '8px',
                                fontWeight: '700',
                                transition: 'all 0.2s',
                                display: 'flex',
                                alignItems: 'center',
                                gap: '6px'
                              }}
                            >
                              👁️ Ver
                            </a>
                            {archivo.tipo_documento.toUpperCase().includes('CUPL') && 
                             tramite.datos_adicionales?.cupl_cargado === true && 
                             (tramite.datos_adicionales?.cupl_pagado !== true || isSuperadmin) && 
                             (!['tramite_ejecutado', 'rechazado', 'eliminado'].includes(tramite.estado) || isSuperadmin) && 
                             user?.profile_name !== 'auxiliar transiapp' && !['auxiliar_concesionario', 'administrativo_concesionario'].includes(user?.profile_name) &&
                             (user?.role === 'superadmin' || user?.transito_id) && (
                              <button
                                type="button"
                                onClick={() => isSuperadmin ? handleEliminarArchivoSuperadmin(archivo.id, 'CUPL') : handleEliminarCUPL()}
                                disabled={updating}
                                style={{
                                  padding: '8px 14px',
                                  fontSize: '13px',
                                  background: '#ef4444',
                                  color: '#ffffff',
                                  border: 'none',
                                  borderRadius: '8px',
                                  fontWeight: '700',
                                  cursor: 'pointer'
                                }}
                                title="Eliminar CUPL del trámite y del sistema de pagos"
                              >
                                🗑️ Eliminar CUPL
                              </button>
                            )}
                            {isSuperadmin && !archivo.tipo_documento.toUpperCase().includes('CUPL') && (
                              <button
                                type="button"
                                onClick={() => handleEliminarArchivoSuperadmin(archivo.id, archivo.nombre_mostrar || archivo.tipo_documento)}
                                disabled={updating}
                                style={{
                                  padding: '8px 14px',
                                  fontSize: '13px',
                                  background: '#ef4444',
                                  color: '#ffffff',
                                  border: 'none',
                                  borderRadius: '8px',
                                  fontWeight: '700',
                                  cursor: 'pointer'
                                }}
                                title="Eliminar documento por Superadmin"
                              >
                                🗑️ Eliminar
                              </button>
                            )}
                          </div>
                        </div>
                      ))
                    ) : (
                      <div style={{ textAlign: 'center', padding: '30px', background: '#f8fafc', borderRadius: '12px', border: '2px dashed #e2e8f0' }}>
                        <p style={{ color: '#64748b', margin: 0, fontStyle: 'italic' }}>No se han cargado documentos para este trámite.</p>
                      </div>
                    )}
                  </div>


                  {/* Historial de Estados */}
                  {tramite.estado_historial && tramite.estado_historial.length > 0 && (
                    <div style={{ marginTop: '25px' }}>
                      <h4 style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '15px', color: '#1e293b' }}>
                        🕐 Historial de Estados
                      </h4>
                      <div style={{ display: 'flex', flexDirection: 'column', gap: '0', position: 'relative' }}>
                        {tramite.estado_historial.map((h, idx) => (
                          <div key={h.id} style={{ display: 'flex', gap: '12px', position: 'relative' }}>
                            {/* Línea vertical */}
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', minWidth: '20px' }}>
                              <div style={{ 
                                width: '12px', height: '12px', borderRadius: '50%', 
                                background: idx === tramite.estado_historial.length - 1 ? '#2563eb' : '#94a3b8',
                                border: idx === tramite.estado_historial.length - 1 ? '3px solid #bfdbfe' : '2px solid #cbd5e1',
                                zIndex: 1, flexShrink: 0
                              }} />
                              {idx < tramite.estado_historial.length - 1 && (
                                <div style={{ width: '2px', background: '#e2e8f0', flexGrow: 1, minHeight: '30px' }} />
                              )}
                            </div>
                            {/* Contenido */}
                            <div style={{ paddingBottom: '16px', flex: 1 }}>
                              <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                {h.estado_anterior && (
                                  <>
                                    <span style={{ fontSize: '11px', padding: '2px 6px', borderRadius: '4px', background: '#f1f5f9', color: '#64748b', fontWeight: '600' }}>
                                      {getStatusInfo(h.estado_anterior).label}
                                    </span>
                                    <span style={{ color: '#94a3b8', fontSize: '12px' }}>→</span>
                                  </>
                                )}
                                <span style={{ fontSize: '11px', padding: '2px 6px', borderRadius: '4px', background: '#dbeafe', color: '#1e40af', fontWeight: '600' }}>
                                  {getStatusInfo(h.estado_nuevo).label}
                                </span>
                              </div>
                              <p style={{ margin: '4px 0 0', fontSize: '12px', color: '#64748b' }}>
                                {new Date(h.created_at).toLocaleString('es-CO')} — <span style={{ fontWeight: '600' }}>
                                  {user?.transito_id ? 'TransiApp' : (h.usuario_nombre || 'Sistema')}
                                </span>
                              </p>
                              {h.observaciones && (
                                <p style={{ margin: '2px 0 0', fontSize: '11px', color: '#94a3b8', fontStyle: 'italic' }}>
                                  {h.observaciones}
                                </p>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '40px' }}>
              <p>No se pudo cargar la información del trámite.</p>
            </div>
          )}

          {/* Acciones del Modal */}
          <div className="modal-actions" style={{ borderTop: '1px solid #e2e8f0', paddingTop: '30px', marginTop: '40px', display: 'flex', justifyContent: 'flex-end', gap: '15px' }}>
            {tramite && (
              <button 
                type="button"
                onClick={() => setShowNovedadesModal(true)}
                className="btn-secondary"
                style={{ padding: '10px 20px', borderRadius: '10px', fontWeight: '600', background: '#fef3c7', color: '#92400e', border: '1px solid #fde68a', cursor: 'pointer' }}
              >
                📋 Novedades {tramite.pending_novelties_count > 0 ? `(${tramite.pending_novelties_count})` : ''}
              </button>
            )}
           {tramite && user?.profile_name !== 'auxiliar transiapp' && !['auxiliar_concesionario', 'administrativo_concesionario'].includes(user?.profile_name) && 
             (user?.role === 'superadmin' || !!user?.transito_id || user?.role === 'transito') &&
             tramite.datos_adicionales?.soat_aprobado === true && 
             tramite.datos_adicionales?.cupl_pagado === true && 
             (tramite.factura_count === undefined || tramite.factura_count > 0 || tramite.datos_adicionales?.tipo_flujo === 'otros_tramites') &&
             !['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa'].includes(tramite.estado) && (
              <button 
                type="button" 
                onClick={() => {
                  if (window.confirm('¿Está seguro de finalizar y ejecutar este trámite? Esta acción es definitiva.')) {
                    handleAction('tramite_ejecutado');
                  }
                }} 
                className="btn-primary" 
                disabled={updating || (tramite.pending_novelties_count > 0) || (tramite.intentos_ejecucion || []).some(i => i.status === 'activo' && i.bloquea_finalizar)}
                style={{ padding: '10px 25px', borderRadius: '10px', fontWeight: '600', background: 'var(--primary-color, #2563eb)', color: '#fff', border: 'none', cursor: 'pointer' }}
                title={tramite.pending_novelties_count > 0 ? "No se puede finalizar: tiene novedades pendientes" : "Finalizar Trámite"}
              >
                🔒 Finalizar Trámite
              </button>
            )}
            {tramite && user?.profile_name !== 'auxiliar transiapp' && !['auxiliar_concesionario', 'administrativo_concesionario'].includes(user?.profile_name) &&
             (user?.role === 'superadmin' || !!user?.transito_id || user?.role === 'transito') &&
             tramite.datos_adicionales?.soat_aprobado === true &&
             tramite.datos_adicionales?.cupl_pagado === true &&
             !(tramite.intentos_ejecucion || []).some(i => i.status === 'activo' && i.bloquea_finalizar) &&
             !['tramite_ejecutado', 'placa_en_camino', 'placa_entregada', 'placa_confirmada', 'incidencia_placa', 'rechazado', 'eliminado'].includes(tramite.estado) && (
              <button
                type="button"
                onClick={() => setShowNoEjecModal(true)}
                disabled={updating}
                style={{ padding: '10px 20px', borderRadius: '10px', fontWeight: '600', background: '#d97706', color: '#fff', border: 'none', cursor: 'pointer' }}
                title="Registrar intento de ejecución no exitoso"
              >
                ⛔ No ejecutado
              </button>
            )}
            <button type="button" onClick={onClose} className="btn-secondary" disabled={updating} style={{ padding: '10px 25px', borderRadius: '10px', fontWeight: '600' }}>
              Cerrar
            </button>
          </div>
        </div>
      </div>

      <CargarCUPLModal
        isOpen={showCUPLModal}
        tramite={tramite}
        onClose={() => setShowCUPLModal(false)}
        onSuccess={() => {
          fetchTramiteDetalle();
          if (onUpdate) onUpdate();
        }}
      />

      <CargarLiquidacionModal
        isOpen={showLiquidacionModal}
        tramite={tramite}
        onClose={() => setShowLiquidacionModal(false)}
        onSuccess={() => {
          fetchTramiteDetalle();
          if (onUpdate) onUpdate();
        }}
      />

      <NoEjecutadoModal
        isOpen={showNoEjecModal}
        tramite={tramite}
        onClose={() => setShowNoEjecModal(false)}
        onSuccess={() => {
          fetchTramiteDetalle();
          if (onUpdate) onUpdate();
        }}
      />

      <NovedadesTramiteModal
        isOpen={showNovedadesModal}
        tramiteId={tramiteId}
        onClose={() => setShowNovedadesModal(false)}
        onSuccess={() => {
          fetchTramiteDetalle();
          if (onUpdate) onUpdate();
        }}
      />
    </div>
  );
};

export default DetalleTramiteModal;
